<script>
import DeleteAccountDialog from './deleteAccount/DeleteAccountDialog.vue'
export default {
  name: 'DeleteAccount',
  components: { DeleteAccountDialog },
}
</script>
<template>
  <div>
    <v-card flat tile outlined color="transparent" class="pa-4">
      <v-card-text>
        <v-row align="center" justify="center">
          <v-col cols="12" md="6">
            <v-row class="mb-4">
              <v-col>
                <v-card outlined>
                  <v-card-title>
                    <v-spacer />
                    <v-row class="pl-2">
                      <v-col cols="12" class="justify-center">
                        <span>{{ $t('component.profile.accountManagement.delete.account.header') }}</span>
                      </v-col>
                    </v-row>
                  </v-card-title>
                  <v-card-text>
                    <v-row class="text-center">
                      <v-col class="pt-0">
                        <DeleteAccountDialog />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>